/* eslint-disable no-restricted-globals */
import React, { useState } from 'react';
import {
  MenuItem, IconButton, Grid, makeStyles, Box,
} from '@material-ui/core';
import Bike from 'common/icons/IconBike';
import IconedBox from 'common/components/MainWidgetDialog/IconedBox';
import CloseIcon from '@material-ui/icons/Close';
import { MainWidgetTextField } from 'common/components/MainWidgetDialog/MainWidgetTextField';

import {
  RENTAL_WIDGET_FIELDS,
  ERRORS_PREFIX,
} from 'common/components/MainWidgetDialog/utils/mainWidgetConstants';

import { withTranslation } from 'next-i18next';

const useStyles = makeStyles((theme) => ({
  vehicleCountContainer: ({ bordered }) => ({
    border: bordered ? `1px solid ${theme.palette.grey[100]}` : null,
    backgroundColor: theme.palette.common.white,
    '& .VCCloseIcon': {
      borderLeft: `1px solid ${theme.palette.grey[100]}`,
      borderRadius: 0,
      padding: '0',
      width: theme.typography.pxToRem(44),
      height: '100%',
    },
    '& .numberMotoField': {
      border: bordered ? `1px solid ${theme.palette.grey[100]}` : null,
      [theme.breakpoints.down('md')]: {
        border: `1px solid ${theme.palette.grey[100]}`,
      },
      '& .MuiFilledInput-root': {
        '&.Mui-disabled': {
          backgroundColor: `${theme.palette.action.disabledBackground} !important`,
        },
      },
    },
    '& .dsf': {
      '& .MuiInputBase-input.MuiFilledInput-input': {
        padding: `${theme.spacing(1, 1, 1, 5.6)} !important`,
      },
      border: bordered ? `1px solid ${theme.palette.grey[100]}` : null,
      [theme.breakpoints.down('md')]: {
        border: `1px solid ${theme.palette.grey[100]}`,
      },
    },
  }),
}));

const VehicleCount = (props) => {
  const {
    errors,
    t,
    handleFormDataChange,
    formData,
    motorcycleList,
    vertical,
    bordered,
    disableVehicleCount,
  } = props;
  const classes = useStyles(props);
  const [showMotorcycleInput, setShowMotorcycleInput] = useState(false);

  const handleColseIconClick = () => {
    setShowMotorcycleInput(false);
    handleFormDataChange(RENTAL_WIDGET_FIELDS.VEHICLES_COUNT, 1);
  };

  return (
    <Box className={classes.vehicleCountContainer}>
      <IconedBox Icon={Bike} error={!!errors[`${ERRORS_PREFIX}vehicles_count`]}>
        {showMotorcycleInput ? (
          <Grid container bordered={vertical || bordered}>
            <Grid item xs>
              <MainWidgetTextField
                id={`${ERRORS_PREFIX}vehicles_count`}
                bordered={vertical || bordered}
                error={!!errors[`${ERRORS_PREFIX}vehicles_count`]}
                // helperText={errors[`${ERRORS_PREFIX}vehicles_count`] || ' '}
                variant="filled"
                value={formData.reservation?.vehicles_count}
                type="number"
                fullWidth
                disabled={disableVehicleCount}
                onChange={(e) => {
                  if (!isNaN(e.target.value)) {
                    const newNumberOfVehicles = e.target.value === '' ? '' : +e.target.value;
                    handleFormDataChange(RENTAL_WIDGET_FIELDS.VEHICLES_COUNT, newNumberOfVehicles);
                  }
                }}
                className="WidgetInput  dsf"
                placeholder={t('fe_es_common_main_widget:number_of_motorcycle')}
                InputLabelProps={{
                  shrink: true,
                }}
                autoFocus
              />
            </Grid>
            <Grid item>
              <IconButton className="VCCloseIcon" onClick={handleColseIconClick}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        ) : (
          <MainWidgetTextField
            select
            bordered={vertical || bordered}
            fullWidth
            disabled={disableVehicleCount}
            id={`${ERRORS_PREFIX}vehicles_count`}
            error={!!errors[`${ERRORS_PREFIX}vehicles_count`]}
            // helperText={errors[`${ERRORS_PREFIX}vehicles_count`] || ''}
            value={formData.reservation?.vehicles_count}
            onChange={(e) => {
              if (e.target.value === '4+') {
                setShowMotorcycleInput(true);
                handleFormDataChange(RENTAL_WIDGET_FIELDS.VEHICLES_COUNT, 4);
              } else {
                handleFormDataChange(RENTAL_WIDGET_FIELDS.VEHICLES_COUNT, +e.target.value);
              }
            }}
            variant="filled"
            className="WidgetInput numberMotoField"
          >
            {motorcycleList.map((option) => (
              <MenuItem key={option} value={option}>
                {`${option} ${
                  +option > 1
                    ? t('fe_es_common_main_widget:motorcycles')
                    : t('fe_es_common_main_widget:motorcycle')
                } `}
              </MenuItem>
            ))}
          </MainWidgetTextField>
        )}
      </IconedBox>
    </Box>
  );
};

export default withTranslation(['fe_es_common_main_widget'])(VehicleCount);
